const fileUploadModalStyle = {
  modalTitleText: {
    textAlign: "center",
    fontSize: "1.25rem",
    fontWeight: "500",
  },
  modalBody: {
    marginBottom: "25px",
    paddingTop: "0px !important",
    textAlign: "center",
    "&.MuiDialogContent-root": {
      padding: "0px",
    },
  },
  modalBodyText: {
    fontSize: "0.9rem",
    fontWeight: "500",
  },
  modalActions: {
    position: "absolute",
  },
  btnIcon: {
    marginRight: "5px",
  },
};

export default fileUploadModalStyle;
